import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function GeceKaygiTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['gece-kaygi-testi']} />;
}
